import * as React from 'react';
import type { FirstPrincipleQuestion } from '../types';
import { AudioPlayer } from '../../onboarding/question/components/audio-player';
import { firstPrinciplesPublicApi } from '../../../api/first-principles/first-principles';
import {
  ConversationWrap,
  MessageRow,
  AvatarWrap,
  AvatarImg,
  MessageContent,
  ListenAndAvatarRow,
  TextContent,
  TextBlock,
} from './first-principles-conversation.styled';

type Props = {
  question: FirstPrincipleQuestion;
  invitationCode: string;
};

export const FpConversation: React.FC<Props> = ({ question, invitationCode }) => {
  const [audioUrl, setAudioUrl] = React.useState<string | null>(null);

  React.useEffect(() => {
    if (!question.has_audio) {
      setAudioUrl(null);
      return;
    }

    let cancelled = false;

    firstPrinciplesPublicApi
      .getAudioStreamUrl(invitationCode, question.id, 'question')
      .then((url) => {
        if (!cancelled) setAudioUrl(url);
      })
      .catch(() => {
        if (!cancelled) setAudioUrl(null);
      });

    return () => { cancelled = true; };
  }, [question.id, question.has_audio, invitationCode]);

  return (
    <ConversationWrap>
      <MessageRow>
        <ListenAndAvatarRow>
          <AvatarWrap>
            <AvatarImg src="/chris.jpg" alt="Chris" />
          </AvatarWrap>

          <AudioPlayer
            {...(audioUrl ? { audioUrl } : {})}
          />
        </ListenAndAvatarRow>

        <MessageContent>
          <TextContent>
            <TextBlock>{question.question}</TextBlock>
          </TextContent>
        </MessageContent>
      </MessageRow>
    </ConversationWrap>
  );
};
